import { Injectable } from '@angular/core';
import { Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SandboxLoadGuard {
  constructor() {}

  public canLoad(_route: Route, _segments: UrlSegment[]): Observable<boolean> | boolean {
    return !environment.production;
  }
}
